<template>
  <div class="biller-list-page page-content">
    <el-row class="page-header -with-search-bar" type="flex" justify="space-between">
      <el-col :span="8">
        <h2 class="page-title">รายชื่อบัญชีผู้ใช้ระบบ</h2>
      </el-col>
      <el-col :span="10">
        <!-- <el-input
          placeholder="ค้นหารายชื่อบริษัท"
          v-model="searchTerm"
          class="input-with-select">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input> -->
      </el-col>
      <el-col :span="5">
        <el-button type="primary" class="search-button" @click.prevent="createCompanyUser">
          เพิ่มบัญชีผู้ใช้ระบบ <i class="el-icon-plus el-icon-right"></i>
        </el-button>
      </el-col>
    </el-row>

    <div class="profile-list-table">
      <el-table
        :data="userListData"
        :default-sort = "{prop: 'email', order: 'ascending'}"
        style="width: 100%">
        <el-table-column
          prop="email"
          label="อีเมล"
          sortable
          class-name="no-wrap"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="name"
          label="ชื่อ"
          sortable
          class-name="no-wrap"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="tel"
          label="โทรศัพท์"
          sortable
          :formatter="telFormatter"
          width="140">
        </el-table-column>
        <el-table-column
          prop="role"
          label="หน้าที่"
          sortable
          :formatter="roleFormatter"
          width="100">
        </el-table-column>
        <!--<el-table-column
          prop="created_at"
          label="วันที่สร้าง"
          width="120"
          :formatter="dateFormatter">
        </el-table-column>
        <el-table-column
          prop="update_at"
          label="วันที่แก้ไขล่าสุด"
          width="120"
          :formatter="dateFormatter">
        </el-table-column>-->
        <el-table-column
          prop="status"
          label="สถานะ"
          width="100"
          :formatter="statusFormatter">
          <template slot-scope="scope">
            <el-tag
              :type="statusTypeFormatter(scope.row)"
              close-transition>{{statusFormatter(scope.row)}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="description"
          label="รายละเอียด"
          min-width="150"
          class-name="desc-col">
        </el-table-column>
        <el-table-column
          fixed="right"
          label="ตัวเลือก"
          header-align="center"
          align="center"
          class-name="action-col"
          width="100">
          <template slot-scope="scope">
            <el-button
              v-if="isBillerAdmin"
              type="primary"
              plain
              size="mini"
              @click.prevent="handleEdit(scope.$index, scope.row)"
              class="action-btn">แก้ไข</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  import moment from 'moment-timezone';
  // import store from '@/store';
  import { createMask } from 'imask';

  const BillerUserListView = {
    name: 'biller-user-list',
    data() {
      return {
        searchTerm: '',
        mask: {
          tel: {
            mask: [
              { mask: '{02}-000-0000' },
              { mask: '{0}00-000-000' },
              { mask: '{0}00-000-0000' },
            ],
          },
        },
      };
    },
    computed: {
      isAuthenticated() {
        return this.$store.getters.idToken;
      },
      isBillerAdmin() {
        if (this.$store.getters.myAdminInfo) {
          return this.$store.getters.myAdminInfo.role === 'ADMIN';
        }
        return false;
      },
      company() {
        return this.$store.getters.currentCompany;
      },
      userList() {
        return this.$store.getters.billerUserList;
      },
      userListData() {
        /* const q = this.searchTerm.trim().toLowerCase();
        if (q !== '') {
          return this.userList.filter((item) => {
            const name = item.name.trim().toLowerCase();
            const email = item.email.trim().toLowerCase();
            const desc = item.description.trim().toLowerCase();
            return name.indexOf(q) !== -1 ||
              email.indexOf(q) !== -1 ||
              desc.indexOf(q) !== -1;
          });
        } */
        return this.userList;
      },
    },
    methods: {
      createCompanyUser() {
        this.$router.push({
          name: 'BillerUserCreate',
        });
      },
      handleEdit(index, row) {
        this.$router.push({
          name: 'BillerUserEdit',
          params: {
            userId: row.id,
          },
        });
      },
      roleFormatter(row) {
        return row.role === 'ADMIN' ? 'Biller Admin' : 'Biller Staff';
      },
      dateFormatter(row, column, cellValue) {
        const date = moment(cellValue).tz(process.env.DEFAULT_TZ);
        if (date.isValid()) {
          return date.format('ll');
        }
        return '-';
      },
      statusFormatter(row) {
        let status = 'Disabled';
        if (row.status === 'blocked') {
          status = 'Blocked';
        } else if (row.status === 'active') {
          status = 'Enabled';
        }
        return status;
      },
      statusTypeFormatter(row) {
        let type = 'info';
        if (row.status === 'blocked') {
          type = 'danger';
        } else if (row.status === 'active') {
          type = 'success';
        }
        return type;
      },
      telFormatter(row, column, cellValue) {
        /* if (cellValue) {
          return this.maskFormatter(cellValue, this.mask.tel);
        }
        return '-'; */
        return cellValue || '-';
      },
      maskFormatter(val, maskOptions) {
        const mask = createMask(maskOptions);
        if (val) {
          return mask.resolve(val.toString());
        }
        return '';
      },
    },
    // Handle Routing
    beforeRouteEnter(to, from, next) {
      next((vm) => {
        // Fetch data
        vm.$store.dispatch('START_CONTENT_LOADING');
        vm.$store.dispatch('GET_BILLER_USER_LIST', vm.$store.getters.billerInfo.id).then(() => {
          vm.$store.dispatch('STOP_CONTENT_LOADING');
        }).catch((err) => {
          vm.$store.dispatch('STOP_CONTENT_LOADING');
          vm.$store.dispatch('ADD_ERROR_FLASH', err);
        });
        vm.$store.dispatch('SELECT_CURRENT_COMPANY', vm.companyId);
      });
    },
  };
  export default BillerUserListView;
</script>



// WEBPACK FOOTER //
// src/pages/biller/user-list.vue